module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1090.93529fc4.png";